const GLOBAL_OVERLAY_ID = 'global-loading-overlay';

export function showGlobalLoadingOverlay() {
    const overlay = document.getElementById(GLOBAL_OVERLAY_ID);

    if (overlay) {
        overlay.classList.remove('d-none');
    }
}

export function hideGlobalLoadingOverlay() {
    const overlay = document.getElementById(GLOBAL_OVERLAY_ID);

    if (overlay) {
        overlay.classList.add('d-none');
    }
}
